module.exports = __webpack_public_path__ + "static/media/user7.66545a30.gif";